import {PageModel} from "./page-model";

export function updatePageModelReducer(pageModel: PageModel, updateModel: Partial<PageModel>): PageModel {
  return {...pageModel, ...updateModel};
}
